"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePunchSection = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const luxon_1 = require("luxon");
const hooks_1 = require("../../../hooks");
const PunchSectionTypes_1 = require("../../../components/PunchSection/PunchSectionTypes");
const usePunchSection = ({ punchesTimeSegments, punchWithTimespans, selectedDate, punchCorrections, ctkPolicy, associateInfo, isPunchCorrStatusEnabled, isSubmitMissedPunchV2Enabled, useUnifiedPunchesAPI, usageLocation }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { submitPunchState: { loading: submitPunchLoading, data: submitPunchTime, error: submitPunchError, retry: submitPunchRetry }, submitPunch } = (0, hooks_1.useSubmitPunch)(Object.assign(Object.assign({}, associateInfo), { ctkPolicy,
        usageLocation, useV2Api: isSubmitMissedPunchV2Enabled }));
    const { editPunchState: { loading: editPunchLoading, data: editPunchData, error: editPunchError }, editPunch } = (0, hooks_1.useEditPunch)(Object.assign(Object.assign({}, associateInfo), { usageLocation }));
    const { deletePunchState: { loading: deletePunchLoading, data: deletePunchTime, error: deletePunchError, retry: deletePunchRetry }, deletePunch } = (0, hooks_1.useDeletePunch)(Object.assign(Object.assign({}, associateInfo), { useV2Api: isPunchCorrStatusEnabled, usageLocation }));
    const { acceptPunchCorrectionState: { loading: acceptPunchCorrectionLoading, data: acceptCorrectionId, error: acceptPunchCorrectionError, retry: acceptPunchCorrectionRetry }, acceptPunchCorrection } = (0, hooks_1.useAcceptPunchCorrection)(Object.assign(Object.assign({}, associateInfo), { usageLocation }));
    const { updatePunchCorrectionState: { loading: updatePunchCorrectionLoading, data: updateCorrectionData, error: updatePunchCorrectionError, retry: updatePunchCorrectionRetry }, updatePunchCorrection } = (0, hooks_1.useUpdatePunchCorrection)(Object.assign(Object.assign({}, associateInfo), { usageLocation }));
    const [expandSection, setExpandSection] = react_1.default.useState(true);
    const [punchToastModalState, setPunchToastModalState] = react_1.default.useState(PunchSectionTypes_1.PunchToastModalState.CLOSE);
    const [hideErrorModal, setHideErrorModal] = react_1.default.useState(false);
    const [editingPunch, setEditingPunch] = react_1.default.useState('');
    const editPunchCorrDateTime = (0, react_1.useRef)(luxon_1.DateTime.now());
    const today = luxon_1.DateTime.now();
    const prevDate = today.minus({ days: 6 });
    const punchTimeComp = (a, b) => {
        var _a, _b;
        const aToUse = (_a = a.startDateTime) !== null && _a !== void 0 ? _a : a.endDateTime;
        const bToUse = (_b = b.startDateTime) !== null && _b !== void 0 ? _b : b.endDateTime;
        const aStart = aToUse ? luxon_1.DateTime.fromISO(aToUse) : selectedDate;
        const bStart = bToUse ? luxon_1.DateTime.fromISO(bToUse) : selectedDate;
        return aStart <= bStart ? -1 : 1;
    };
    const sortedTimeSegments = punchesTimeSegments &&
        !!punchesTimeSegments.length &&
        punchesTimeSegments.sort(punchTimeComp);
    const punchTimespanComp = (a, b) => {
        var _a, _b, _c, _d, _e, _f;
        const aToUse = (_b = (_a = a.startSpan) === null || _a === void 0 ? void 0 : _a.punchDateTime.timestamp) !== null && _b !== void 0 ? _b : (_c = a.endSpan) === null || _c === void 0 ? void 0 : _c.punchDateTime.timestamp;
        const bToUse = (_e = (_d = b.startSpan) === null || _d === void 0 ? void 0 : _d.punchDateTime.timestamp) !== null && _e !== void 0 ? _e : (_f = b.endSpan) === null || _f === void 0 ? void 0 : _f.punchDateTime.timestamp;
        const aStart = aToUse ? luxon_1.DateTime.fromISO(aToUse) : selectedDate;
        const bStart = bToUse ? luxon_1.DateTime.fromISO(bToUse) : selectedDate;
        return aStart <= bStart ? -1 : 1;
    };
    const sortedPunchWithTimespans = punchWithTimespans &&
        !!punchWithTimespans.length &&
        punchWithTimespans.sort(punchTimespanComp);
    let punchToastModalTitle;
    let punchToastModalText;
    let punchToastModalNote;
    let punchToastModalCloseBtnText;
    if (punchToastModalState === PunchSectionTypes_1.PunchToastModalState.SUBMIT_MISSED_PUNCH) {
        punchToastModalTitle = t('time_and_attendance_PunchToastModal_MissedPunch_Title');
        const punchDateTime = luxon_1.DateTime.fromISO(submitPunchTime);
        punchToastModalText = t('time_and_attendance_PunchToastModal_MissedPunch_Text', {
            punchDate: punchDateTime.toLocaleString({
                month: 'long',
                day: 'numeric'
            }),
            punchTime: punchDateTime.toLocaleString(luxon_1.DateTime.TIME_SIMPLE)
        });
    }
    else if (punchToastModalState === PunchSectionTypes_1.PunchToastModalState.SUBMIT_PUNCH_EDIT) {
        punchToastModalTitle = t('time_and_attendance_Success');
        punchToastModalText = t('time_and_attendance_PunchToastModal_PunchEdit_Success_Text');
        punchToastModalNote = t('time_and_attendance_PunchToastModal_PunchEdit_Note_Text');
        punchToastModalCloseBtnText = t('time_and_attendance_Close');
    }
    else if (punchToastModalState === PunchSectionTypes_1.PunchToastModalState.DELETE_PUNCH) {
        punchToastModalTitle = t('time_and_attendance_PunchToastModal_PunchDeleted');
        const punchDateTime = luxon_1.DateTime.fromISO(deletePunchTime);
        punchToastModalText = t('time_and_attendance_PunchToastModal_DeletePunch_Text', {
            punchDate: punchDateTime.toLocaleString({
                month: 'long',
                day: 'numeric'
            }),
            punchTime: punchDateTime.toLocaleString(luxon_1.DateTime.TIME_SIMPLE)
        });
    }
    else {
        const getAcceptPunchCorrTime = (id) => {
            const punchCorrection = punchCorrections === null || punchCorrections === void 0 ? void 0 : punchCorrections.find((corr) => corr.correctionId === id);
            return punchCorrection
                ? luxon_1.DateTime.fromISO(punchCorrection.correctionDateTime)
                : luxon_1.DateTime.now();
        };
        const correctionDateTime = punchToastModalState === PunchSectionTypes_1.PunchToastModalState.ACCEPT_PUNCH_CORRECTION
            ? getAcceptPunchCorrTime(acceptCorrectionId)
            : editPunchCorrDateTime.current;
        punchToastModalTitle = t('time_and_attendance_PunchToastModal_PunchCorrection_Title');
        punchToastModalText = t('time_and_attendance_PunchToastModal_PunchCorrection_Text', {
            correctionDate: correctionDateTime.toLocaleString({
                month: 'long',
                day: 'numeric'
            }),
            correctionTime: correctionDateTime.toLocaleString(luxon_1.DateTime.TIME_SIMPLE)
        });
    }
    const isPunchUpdating = submitPunchLoading ||
        editPunchLoading ||
        deletePunchLoading ||
        acceptPunchCorrectionLoading ||
        updatePunchCorrectionLoading;
    const shouldShowPunchToast = !isPunchUpdating &&
        !submitPunchError &&
        !editPunchError &&
        !deletePunchError &&
        !acceptPunchCorrectionError &&
        !updatePunchCorrectionError &&
        punchToastModalState !== PunchSectionTypes_1.PunchToastModalState.CLOSE &&
        (!!submitPunchTime ||
            !!editPunchData ||
            !!deletePunchTime ||
            !!acceptCorrectionId ||
            !!updateCorrectionData);
    const isPunchUpdatedWithError = !isPunchUpdating &&
        !hideErrorModal &&
        (!!submitPunchError ||
            !!deletePunchError ||
            !!acceptPunchCorrectionError ||
            !!updatePunchCorrectionError);
    const punchErrorModalRetry = () => {
        setHideErrorModal(false);
        if (submitPunchError) {
            setPunchToastModalState(PunchSectionTypes_1.PunchToastModalState.SUBMIT_MISSED_PUNCH);
            submitPunchRetry();
        }
        else if (deletePunchError) {
            setPunchToastModalState(PunchSectionTypes_1.PunchToastModalState.DELETE_PUNCH);
            deletePunchRetry();
        }
        else if (acceptPunchCorrectionError) {
            setPunchToastModalState(PunchSectionTypes_1.PunchToastModalState.ACCEPT_PUNCH_CORRECTION);
            acceptPunchCorrectionRetry();
        }
        else if (updatePunchCorrectionError) {
            setPunchToastModalState(PunchSectionTypes_1.PunchToastModalState.UPDATE_PUNCH_CORRECTION);
            updatePunchCorrectionRetry();
        }
    };
    const punchErrorModalClose = () => setHideErrorModal(true);
    const getEditedPunchString = () => {
        const punchDate = luxon_1.DateTime.fromISO(editingPunch);
        const month = t(`time_and_attendance_PunchCard_daySelector_${punchDate.month}`);
        const timeString = punchDate.toLocaleString(luxon_1.DateTime.TIME_SIMPLE);
        const day = punchDate.day;
        const year = punchDate.year;
        return `${timeString} | ${month} ${day}, ${year}`;
    };
    let punchErrorModalId, punchErrorModalTitle, punchErrorModalSubTitle, punchErrorModalSubText, punchErrorModalTextKey, punchErrorModalText;
    if (editPunchError &&
        editPunchError.statusCode === 400 &&
        editPunchError.message.includes('MealLockout')) {
        punchErrorModalTitle = t('time_and_attendance_PunchStatusModal_NotAcceptedTitle');
        punchErrorModalId = 'punch-edit-mealbreak-error-modal';
        punchErrorModalText = t('time_and_attendance_PunchModal_PunchEditError_MealBreakLockout');
        punchToastModalCloseBtnText = t('time_and_attendance_Close');
        punchErrorModalSubTitle = t('time_and_attendance_PunchCorrectionType_EditedPunch');
        punchErrorModalSubText = editingPunch ? getEditedPunchString() : undefined;
    }
    else if (editPunchError) {
        punchErrorModalTitle = t('time_and_attendance_system_error');
        punchErrorModalId = 'punch-edit-error-modal';
        punchErrorModalText = t('time_and_attendance_PunchToastModal_PunchEdit_Error_Text');
        punchToastModalCloseBtnText = t('time_and_attendance_Close');
        punchErrorModalSubTitle = undefined;
        punchErrorModalSubText = undefined;
    }
    else if (deletePunchError) {
        punchErrorModalTitle = t('time_and_attendance_PunchToastModal_Error');
        punchErrorModalId = 'deletion-error-modal';
        punchErrorModalTextKey =
            deletePunchError && deletePunchError.statusCode === 404
                ? 'time_and_attendance_PunchToastModal_DeletePunch_DuplicateDeletionErrorText'
                : 'time_and_attendance_PunchToastModal_DeletePunch_GeneralErrorText';
        punchErrorModalText = t(punchErrorModalTextKey);
        punchErrorModalSubTitle = undefined;
        punchErrorModalSubText = undefined;
    }
    const punchTotal = useUnifiedPunchesAPI
        ? (punchWithTimespans || []).reduce((acc, cur) => {
            const timeInCount = cur.startSpan ? 1 : 0;
            const timeOutCount = cur.endSpan ? 1 : 0;
            return acc + timeInCount + timeOutCount;
        }, 0)
        : (punchesTimeSegments || []).reduce((acc, cur) => {
            const timeInCount = cur.startDateTime ? 1 : 0;
            const timeOutCount = cur.endDateTime ? 1 : 0;
            return acc + timeInCount + timeOutCount;
        }, 0);
    const missedPunchTotal = useUnifiedPunchesAPI
        ? 2 * ((punchWithTimespans === null || punchWithTimespans === void 0 ? void 0 : punchWithTimespans.length) || 0) - punchTotal
        : 2 * ((punchesTimeSegments === null || punchesTimeSegments === void 0 ? void 0 : punchesTimeSegments.length) || 0) - punchTotal;
    const setExpandSectionback = react_1.default.useCallback((event) => {
        if (event) {
            event.stopPropagation();
        }
        setExpandSection(!expandSection);
    }, [expandSection]);
    return {
        sortedTimeSegments,
        sortedPunchWithTimespans,
        expandSection,
        setExpandSection,
        setPunchToastModalState,
        hideErrorModal: hideErrorModal,
        setHideErrorModal,
        editPunchCorrDateTime,
        today,
        prevDate,
        punchToastModalTitle,
        punchToastModalText,
        punchToastModalNote,
        punchToastModalCloseBtnText,
        isPunchUpdating,
        shouldShowPunchToast,
        isPunchUpdatedWithError,
        deletePunchError,
        punchErrorModalRetry,
        submitPunch,
        deletePunch,
        acceptPunchCorrection,
        updatePunchCorrection,
        punchErrorModalClose,
        punchErrorModalId,
        punchErrorModalTitle,
        punchErrorModalTextKey,
        punchErrorModalText,
        punchErrorModalSubTitle,
        punchErrorModalSubText,
        punchTotal,
        missedPunchTotal,
        setExpandSectionback,
        editPunch,
        editPunchError,
        editingPunch,
        setEditingPunch,
        getEditedPunchString
    };
};
exports.usePunchSection = usePunchSection;
